import { useState } from 'react';

export function useToggle(defaultValue?: boolean) {
  const [value, setValue] = useState(defaultValue);
  const toggleValue = () => setValue((prev) => !prev);
  return [value, toggleValue] as const;
}
